import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomNav from '../components/BottomNav';
import { openKakaoChat, openKakaoPlusFriend } from '../utils/kakaoAuth';
import './MainLayout.css';

const MainLayout = () => {
  const location = useLocation();
  const showFloatingButtons = location.pathname === '/notifications';

  const handleKakaoClick = () => {
    // Option 1: Kakao Plus Friend (Channel) - Best for business support (1-1 chat)
    const kakaoPlusFriendId = process.env.REACT_APP_KAKAO_PLUS_FRIEND_ID;

    // Option 2: Kakao Open Chat (Group chat)
    const kakaoOpenChatId = process.env.REACT_APP_KAKAO_CHAT_ID;

    // Option 3: Direct Kakao ID (temporary solution)
    const kakaoDirectId = process.env.REACT_APP_KAKAO_DIRECT_ID || 'dmh135@gmail.com';

    console.log('[Kakao] Button clicked:', { kakaoPlusFriendId, kakaoOpenChatId, kakaoDirectId });

    // Try Plus Friend first (1-1 chat with business), then fallback to Open Chat
    if (kakaoPlusFriendId) {
      // Open Kakao Plus Friend chat (tries app first, then web)
      console.log('[Kakao] Opening Plus Friend:', kakaoPlusFriendId);
      openKakaoPlusFriend(kakaoPlusFriendId);
    } else if (kakaoOpenChatId) {
      // Fallback to Open Chat (group chat)
      console.log('[Kakao] Opening Open Chat:', kakaoOpenChatId);
      openKakaoChat(kakaoOpenChatId);
    } else {
      // Final fallback - Try to open Kakao app with search
      // This will open Kakao app and search for the ID
      console.log('[Kakao] Using direct ID fallback');

      // Method 1: Try Kakao app deep link (search by ID)
      const kakaoAppUrl = `kakaotalk://search?q=${encodeURIComponent(kakaoDirectId)}`;

      // Method 2: Web fallback - open Kakao Talk web
      const kakaoWebUrl = 'https://talk.kakao.com';

      // Try to open app first
      const startTime = Date.now();
      window.location.href = kakaoAppUrl;

      // If app doesn't open after 1.5 seconds, show instructions
      setTimeout(() => {
        const elapsed = Date.now() - startTime;
        if (elapsed >= 1500) {
          alert(`카카오톡 앱에서 "${kakaoDirectId}" 을(를) 검색하세요.\n\nSearch "${kakaoDirectId}" in KakaoTalk app.`);
        }
      }, 1500);
    }
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:010-8351-1179';
  };

  return (
    <div className="main-layout">
      <main className="main-content">
        <Outlet />
      </main>
      <BottomNav />

      {/* Floating Contact Buttons - Only show on /notifications page */}
      {showFloatingButtons && (
        <div className="floating-buttons">
        <button
          className="floating-btn kakao-btn"
          onClick={handleKakaoClick}
          aria-label="Contact via KakaoTalk"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M12 3c5.799 0 10.5 3.664 10.5 8.185 0 4.52-4.701 8.184-10.5 8.184a13.5 13.5 0 0 1-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866C1.5 6.665 6.201 3 12 3zm5.907 8.06l1.47-1.424a.472.472 0 0 0-.656-.681l-1.928 1.866V9.282a.472.472 0 0 0-.944 0v2.557a.471.471 0 0 0 0 .222V13.5a.472.472 0 0 0 .944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 1 0 .773-.543l-1.514-2.155zm-2.958 1.924h-1.46V9.297a.472.472 0 0 0-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 1 0 0-.944zm-5.857-1.092l.696-1.707.638 1.707H9.092zm2.523.488l.002-.016a.469.469 0 0 0-.127-.32l-1.046-2.8a.69.69 0 0 0-.627-.474.696.696 0 0 0-.653.447l-1.661 4.075a.472.472 0 0 0 .874.357l.33-.817h2.07l.299.817a.472.472 0 1 0 .884-.325l-.345-.944zM8.293 9.302a.472.472 0 0 0-.471-.472H4.577a.472.472 0 1 0 0 .944h1.16v3.736a.472.472 0 0 0 .944 0V9.774h1.14c.261 0 .472-.212.472-.472z"/>
          </svg>
        </button>
        <button
          className="floating-btn phone-btn"
          onClick={handlePhoneClick}
          aria-label="Call us"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
          </svg>
        </button>
        </div>
      )}
    </div>
  );
};

export default MainLayout;
